module.exports = __webpack_public_path__ + "img/9788997414383.97236adb.jpg";